export default function removeNullOrUndefinedOrEmpty(obj: unknown): unknown {
	if (obj === null || obj === undefined) return {}

	if (Array.isArray(obj)) {
		// Clean each item in the array
		return obj
			.filter(item => item !== null && item !== undefined && item !== '' && item !== 'null')
			.map(item => (typeof item === 'object' && item !== null ? removeNullOrUndefinedOrEmpty(item) : item))
	}

	if (typeof obj !== 'object') return obj

	const result: Record<string, unknown> = {}

	for (const key in obj as Record<string, unknown>) {
		if (!Object.prototype.hasOwnProperty.call(obj, key)) continue

		const value = (obj as Record<string, unknown>)[key]

		if (value === null || value === undefined || value === '' || value === 'null') {
			continue
		}

		// Preserve Date objects and objects with toISOString
		if (
			typeof value === 'object' &&
			value !== null &&
			!(value instanceof Date) &&
			!(typeof (value as { toISOString?: unknown }).toISOString === 'function')
		) {
			const cleaned = removeNullOrUndefinedOrEmpty(value)
			if (typeof cleaned === 'object' && cleaned !== null && Object.keys(cleaned).length > 0) {
				result[key] = cleaned
			}
		} else {
			result[key] = value
		}
	}

	return result
}
